<div class="component-left-view helper-top-padding">
  <div *ngIf="mainNavigationData">
    <app-main-navigation [navigationItems]="mainNavigationData"></app-main-navigation>
  </div>
  <div *ngIf="isNavigationNotLoaded">
    <app-loader></app-loader>
  </div>
</div>
